import { Paragraph } from 'components/shared'
import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getProductNewAction } from 'store/store/actions'
import { CategoryTypeIds, IPropertyValue } from 'store/taskManager/model'
import { TaskData } from '../TaskAside.style'
import { Box, Button, Tooltip, useHasUserTag } from '@centra/centra-ui'
import PropertyValuesEditModal from '../PropertyValuesEditModal'
import { PRODUCT_PROPERTY_GID } from '../consts'

const PropertyValuesList = () => {
  const dispatch = useDispatch()

  const { task, product } = useSelector(({ taskManager, store }) => ({
    task: taskManager.task,
    product: store.productNew,
  }))

  const [openPropertyValuesModal, setOpenPropertyValuesModal] = useState(false)
  const isEmployeeUser = useHasUserTag(['employeeUser'])

  const productPropertyValue = useMemo(
    () => task?.propertyValues?.find(pv => pv.propertyGid === PRODUCT_PROPERTY_GID),
    [task?.propertyValues]
  )

  useEffect(() => {
    if (task?.propertyValues?.length) {
      // Костыль для получения продукта
      // Сейчас мы не можем хранить и получать конкретный продукт сразу из сущности
      // Идентификатор продукта ложится в БД как параметр при создании задачи
      // TODO: Добавить новый тип параметра entity для выборки записи из сущности по id

      if (productPropertyValue && productPropertyValue.value !== product?.id) {
        dispatch(getProductNewAction({ id: productPropertyValue.value as number }))
      }
    }
  }, [task?.propertyValues])

  const handleModalClose = useCallback(() => setOpenPropertyValuesModal(false), [])

  if (!task?.propertyValues) {
    return null
  }

  return (
    <>
      {task.category.id === CategoryTypeIds.support &&
        task?.propertyValues?.map((pv: IPropertyValue) => (
          <TaskData key={`propertyValue_${pv.propertyId}`}>
            <label>{pv.name}</label>
            {pv.value && Array.isArray(pv.value) ? (
              pv.value.map(value => (
                <Paragraph key={`propertyOptionValue_${value.id}`} size={'sm'}>
                  <b>{value.name}</b>
                </Paragraph>
              ))
            ) : (
              <>
                {product && productPropertyValue?.propertyId === pv.propertyId && (
                  <Paragraph size={'sm'}>
                    <b>{product?.name}</b>
                  </Paragraph>
                )}

                {productPropertyValue?.propertyId !== pv.propertyId && (
                  <Paragraph size={'sm'}>
                    <b>{pv.value}</b>
                  </Paragraph>
                )}
              </>
            )}
          </TaskData>
        ))}

      {isEmployeeUser && (
        <Box>
          {task.category.id === CategoryTypeIds.support ? (
            <Button
              id={'edit_property_values_button'}
              view={'secondaryLight'}
              onClick={() => setOpenPropertyValuesModal(true)}
            >
              Редактировать параметры
            </Button>
          ) : (
            <Tooltip content={'Редактирование недоступно в этой категории'}>
              <Button
                id={'edit_property_values_button'}
                view={'secondaryLight'}
                disabled={true}
                onClick={() => setOpenPropertyValuesModal(true)}
              >
                Редактировать параметры
              </Button>
            </Tooltip>
          )}
          <PropertyValuesEditModal task={task} isOpen={openPropertyValuesModal} onClose={handleModalClose} />
        </Box>
      )}
    </>
  )
}

export default PropertyValuesList
